import "./index.scss";
import React from "react";
import uid from "uid";

const CustomSelect = ({
  selected,
  setSelected,
  isSelectOpened,
  setIsSelectOpened,
}) => {
  const choices = [
    {
      id: "gallery",
      title: "MA Gallery",
    },
    {
      id: "match",
      title: "MA Match",
    },
  ];

  const handleSelect = (item) => {
    setSelected(item);
    setIsSelectOpened(false);
  };
  return (
    <div className={`custom-select`}>
      <div
        className={`custom-select__head ${
          selected && "custom-select__head--active"
        }`}
        onClick={() => setIsSelectOpened(!isSelectOpened)}
      >
        {selected ? selected.title : "Choose"}
      </div>
      <div className={`custom-select__body}`} />
      <ul
        className={`custom-select__body ${
          isSelectOpened && "custom-select__body--shown"
        }`}
      >
        {choices.map((item) => (
          <li
            key={uid()}
            className={`custom-select__item ${
              selected &&
              selected.id === item.id &&
              "custom-select__item--chosen"
            }`}
            onClick={() => handleSelect(item)}
          >
            {item.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomSelect;
